import React from 'react';
import '../css/channelRow.css';

import Avatar from '@material-ui/core/Avatar';
import VerifiedIcon from '@material-ui/icons/CheckCircleTwoTone';

export default function ChannelRow({ image, channel, verified, subs, noOfVideos, description}) {
  return (
    <div className="channelRow">
        <Avatar className="channelRow_avatar"
        alt={channel}
        src={image}
        />
        <div className="channelRow_text">
            <h4>{channel} {verified && <VerifiedIcon/>}</h4>
            <p>{subs} subscribers . {noOfVideos} videos</p>
            <p>{description}</p>
        </div>

    </div>
  );
}
